import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import MonogramOrPhoto from 'garaje/components/monogram-or-photo';
import TruncateWithTooltip from 'garaje/components/truncate-with-tooltip';
import type VisitorProfile from 'garaje/models/visitor-profile';

interface NameCellSignature {
  Args: {
    row: VisitorProfile;
  };
}

export default <template>
  <LinkTo
    @route="visitors.profiles.show"
    @model={{@row.id}}
    class="group flex align-top hover:cursor-pointer hover:no-underline text-carbon-50"
    data-test-name-cell
  >
    <div class="inline-block mr-3">
      <MonogramOrPhoto @name={{@row.displayName}} @passportPhoto={{@row.photoUrl}} @borderBottom={{false}} />
    </div>
    <div class="flex flex-col justify-center pt-1">
      <span
        data-test-name-cell-name
        class="text-carbon-70 font-bold text-base group-hover:text-red-50 group-hover:underline"
      >
        {{@row.displayName}}
      </span>
      <span data-test-name-cell-email class="text-carbon-50 font-normal block">
        <TruncateWithTooltip @value={{@row.primaryEmail}} @length={{25}} @side="bottom" />
      </span>
    </div>
  </LinkTo>
</template> satisfies TOC<NameCellSignature>;
